import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'

export default class KycCheckbox extends React.Component {
  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func,
    options: PropTypes.array,
    errorMessage: PropTypes.object,
    disabled: PropTypes.bool,
    fieldName: PropTypes.string
  }

  addRemoveItem(event) {
    const value = event.target.value

    if (!this.props.value.includes(value)) {
      this.props.onChange([...this.props.value, value])
    } else {
      let resultArray = this.props.value
      resultArray.splice(this.props.value.indexOf(value), 1)

      this.props.onChange(resultArray)
    }
  }

  renderOptions() {
    return this.props.options.map((option, key) => {
      const referenceOptionValue =
        option.value.indexOf(' ') > 0 ? option.value.split(' ')[1] : option.value

      return (
        <div key={key} style={{marginRight: 16, marginBottom: 16}}>
          <input
            className={styles.checkboxChipInput}
            type="checkbox"
            id={referenceOptionValue}
            checked={this.props.value.includes(option.value)}
            name={this.props.fieldName}
            disabled={this.props.disabled}
            onChange={event => this.addRemoveItem(event)}
            value={option.value}
          />
          <label
            className={styles.checkboxChipLabel}
            htmlFor={referenceOptionValue}
            key={option.label}>
            {option.label}
          </label>
        </div>
      )
    })
  }

  render() {
    return (
      <div className={styles.chipsContainer}>
        {this.renderOptions()}
        <div className="os-input-error">{this.props.errorMessage}</div>
      </div>
    )
  }
}
